export function getDefaultOptions() {
    return {
        cols: [],
        data: [],
        rowKey: 'id',
        width: '100%',
        height: 'auto',
        rowHeight: 35,
        defaultColWidth: 80,
        minColWidth: 24,
        maxColWidth: 9999,
        header: true,
        footer: undefined,
        headerHeight: 0,
        footerHeight: 0,
        rowHover: true,
        colHover: false,
        cellHover: false,
        bordered: false,
        striped: true,
        responsive: false,
        scrollbarHover: true,
        horzScrollbarPos: 'outside',
    };
}
